import styled from 'styled-components';
import { breakpoints } from '@config';
import { Text, Title } from '@components';

export interface CircleProps {
  circle: number;
  transparency: number;
}

export interface CirclesWrapProps {
  maxCircle: number;
  runAnimation?: boolean;
}

export const Wrapper = styled.section`
  position: relative;
  overflow: hidden;
  margin-bottom: 112px;
  padding-top: 63px;

  @media (min-width: ${breakpoints.pc}) {
    padding-top: 128px;
    margin-bottom: 0;
  }
`;

export const Head = styled.div`
  max-width: 792px;

  @media (min-width: ${breakpoints.pc}) {
    display: grid;
    grid-template: repeat(2, max-content) / repeat(2, auto);
    grid-template-areas: "title  text  "
                         "button button";
    align-items: center;
    gap: 32px 56px;
    align-self: center;
    margin-bottom: 80px;
  }
`;

export const StyledTitle = styled(Title)`
  grid-area: title;
  margin-bottom: 24px;

  @media (min-width: ${breakpoints.pc}) {
    margin-bottom: 0;
  }
`;

export const StyledText = styled(Text)`
  grid-area: text;
`;

export const ButtonWrapper = styled.div`
  grid-area: button;
`;

export const Picture = styled.picture`
  text-align: center;
  max-width: 100%;
  height: auto;
  margin-bottom: 40px;
  
  & > * {
    max-width: 100%;
    height: auto;
  }

  @media (min-width: ${breakpoints.pc}) {
    margin-bottom: 0;
  }
`;

export const CircleWrap = styled.div<CirclesWrapProps>`
  position: absolute;
  left: 50%;
  top: 0;
  width: ${({ maxCircle }) => maxCircle}px;
  height: ${({ maxCircle }) => (maxCircle / 2)}px;
  transform: ${({ runAnimation }) => runAnimation ? 'translate(-50%, 0)' : 'translate(-50%, 100%)'};
  overflow: hidden;
  transition: 0.5s ease;
  will-change: transform;
  z-index: -1;
  
  &::after {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    content: '';
    background-image: ${({ theme }) => `linear-gradient(transparent 0%, ${theme.colors.bg} 100%)`};
    z-index: 1;
  }

  @media (min-width: ${breakpoints.pc}) {
    transform: ${({ runAnimation }) => runAnimation ? 'translate(-50%, 25%)' : 'translate(-50%, 100%)'};
  }
`;

export const Circle = styled.div<CircleProps>`
  position: absolute;
  bottom: 0;
  left: 50%;
  width: ${({ circle }) => circle}px;
  height: ${({ circle }) => circle}px;
  background: rgba(255, 255, 255, 0.2);
  opacity: ${({ transparency }) => transparency};
  transform: translate(-50%, 50%);
  box-shadow: inset 0 0 80px rgba(255, 255, 255, 0.4);
  border-radius: 50%;
`;
